// GENERATED from combat.store by tools/combat-store.js — do not edit.
// Edit the store (or `npm run knobs`, Combat tab), then re-run the generator.
// The store is the single source of truth; this module is its projection the
// committed default runs against (headless tools, tests, non-dev servers).
export const COMBAT_DATA = {
  "moveCostTicks": 7,
  "roomTiles": 10,
  "inventoryCap": 15,
  "chatMax": 200,
  "respawnDelayTicks": 60,
  "baseAttack": 10,
  "baseMeleeDef": 40,
  "baseMagicDef": 40,
  "baseAtkMin": 1,
  "baseAtkMax": 2,
  "baseSwingTicks": 75,
  "baseDmgMod": 100,
  "accFloorPct": 20,
  "accCapPct": 95,
} as const;
